import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HotArticles() {
  const hotArticles = articles.slice(0, 5);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              热门文章推荐
            </h2>
            <p className="text-foreground-600 text-sm">精心整理的 JavBus 使用指南与教程</p>
          </div>
          <Link
            to="/category/search-tips"
            className="whitespace-nowrap hidden sm:inline-flex items-center text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {hotArticles.map((article, index) => (
            <article
              key={article.slug}
              className="bg-white rounded-lg overflow-hidden hover:bg-background-100 transition-colors cursor-pointer group animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <Link to={`/article/${article.slug}`} className="block p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                    {article.category}
                  </span>
                  <span className="text-foreground-400 text-xs">{article.readTime}</span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-foreground-400 text-xs">{article.date}</span>
                  <div className="flex flex-wrap gap-1">
                    {article.tags.slice(0, 2).map((tag) => (
                      <span key={tag} className="text-foreground-400 text-xs">
                        #{tag}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}